/* ==========================================================================
   VaidicHerb — DESIGN 3 "NURTURE" — shared interactivity
   Cart (localStorage), nav/mobile menu, FAQ accordion, toasts, gallery,
   sticky header, back-to-top, forms.
   ========================================================================== */
(function(){
  "use strict";

  var CART_KEY = "vh3_nurture_cart";
  var PRODUCT = {
    id: "vaidicherb-skin-repair-cream",
    title: "VaidicHerb Skin Repair Cream – Pack of 2 (30g each)",
    price: 299,
    compareAt: 318,
    image: "../shared-assets/products/product-03.png"
  };

  /* ---------------- Cart core ---------------- */
  function getCart(){
    try{
      var raw = localStorage.getItem(CART_KEY);
      return raw ? JSON.parse(raw) : [];
    }catch(e){ return []; }
  }
  function saveCart(cart){
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    renderCart();
  }
  function addToCart(qty){
    qty = qty || 1;
    var cart = getCart();
    var line = cart.find(function(l){ return l.id === PRODUCT.id; });
    if(line){ line.qty += qty; }
    else{ cart.push({ id: PRODUCT.id, title: PRODUCT.title, price: PRODUCT.price, image: PRODUCT.image, qty: qty }); }
    saveCart(cart);
    openCart();
    showToast("Added to cart — " + PRODUCT.title.split("–")[0].trim());
  }
  function updateQty(id, delta){
    var cart = getCart();
    var line = cart.find(function(l){ return l.id === id; });
    if(!line) return;
    line.qty += delta;
    if(line.qty <= 0){ cart = cart.filter(function(l){ return l.id !== id; }); }
    saveCart(cart);
  }
  function removeLine(id){
    var cart = getCart().filter(function(l){ return l.id !== id; });
    saveCart(cart);
  }
  function cartCount(){
    return getCart().reduce(function(n,l){ return n + l.qty; }, 0);
  }
  function cartSubtotal(){
    return getCart().reduce(function(n,l){ return n + l.qty * l.price; }, 0);
  }

  function renderCart(){
    var body = document.querySelector("[data-cart-body]");
    var subtotalEl = document.querySelector("[data-cart-subtotal]");
    var countEls = document.querySelectorAll("[data-cart-count]");
    var cart = getCart();
    var count = cartCount();

    countEls.forEach(function(el){
      el.textContent = count;
      el.classList.toggle("show", count > 0);
    });

    if(subtotalEl){ subtotalEl.textContent = "₹" + cartSubtotal(); }

    if(!body) return;
    body.innerHTML = "";
    if(cart.length === 0){
      body.innerHTML =
        '<div class="cart-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
          '<p style="font-weight:700;color:var(--vh-ink);margin-bottom:6px;">Your cart is feeling light</p>' +
          '<p style="font-size:var(--fs-xs);">Add the VaidicHerb Skin Repair Cream and give your skin some herbal pyaar.</p>' +
        '</div>';
      return;
    }
    cart.forEach(function(line){
      var div = document.createElement("div");
      div.className = "cart-line";
      div.innerHTML =
        '<img src="' + line.image + '" alt="' + line.title + '">' +
        '<div class="cart-line-info">' +
          '<div class="t">' + line.title + '</div>' +
          '<div class="p">₹' + line.price + ' × ' + line.qty + '</div>' +
          '<div class="cart-line-actions">' +
            '<div class="qty-stepper" data-cart-qty="' + line.id + '">' +
              '<button type="button" aria-label="Decrease quantity" data-cart-dec>−</button>' +
              '<span>' + line.qty + '</span>' +
              '<button type="button" aria-label="Increase quantity" data-cart-inc>+</button>' +
            '</div>' +
            '<button type="button" class="cart-remove" data-cart-remove aria-label="Remove ' + line.title + '">Remove</button>' +
          '</div>' +
        '</div>';
      div.querySelector("[data-cart-dec]").addEventListener("click", function(){ updateQty(line.id, -1); });
      div.querySelector("[data-cart-inc]").addEventListener("click", function(){ updateQty(line.id, 1); });
      div.querySelector("[data-cart-remove]").addEventListener("click", function(){ removeLine(line.id); });
      body.appendChild(div);
    });
  }

  function openCart(){
    var drawer = document.querySelector("[data-cart-drawer]");
    var overlay = document.querySelector("[data-overlay]");
    if(drawer){ drawer.classList.add("open"); }
    if(overlay){ overlay.classList.add("show"); }
    document.body.style.overflow = "hidden";
  }
  function closeCart(){
    var drawer = document.querySelector("[data-cart-drawer]");
    var overlay = document.querySelector("[data-overlay]");
    var menu = document.querySelector("[data-mobile-menu]");
    var isMenuOpen = menu && menu.classList.contains("open");
    if(drawer){ drawer.classList.remove("open"); }
    if(!isMenuOpen){
      if(overlay){ overlay.classList.remove("show"); }
      document.body.style.overflow = "";
    }
  }

  /* ---------------- Toast ---------------- */
  function showToast(msg){
    var wrap = document.querySelector("[data-toast-wrap]");
    if(!wrap) return;
    var t = document.createElement("div");
    t.className = "toast";
    t.setAttribute("role","status");
    t.innerHTML = '<span class="dot"></span><span>' + msg + '</span>';
    wrap.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add("show"); });
    setTimeout(function(){
      t.classList.remove("show");
      setTimeout(function(){ t.remove(); }, 350);
    }, 3000);
  }

  /* ---------------- Mobile menu ---------------- */
  function initMobileMenu(){
    var btn = document.querySelector("[data-hamburger]");
    var menu = document.querySelector("[data-mobile-menu]");
    var overlay = document.querySelector("[data-overlay]");
    var closeBtn = document.querySelector("[data-mobile-close]");
    function open(){
      btn && btn.classList.add("open");
      menu && menu.classList.add("open");
      overlay && overlay.classList.add("show");
      document.body.style.overflow = "hidden";
    }
    function close(){
      btn && btn.classList.remove("open");
      menu && menu.classList.remove("open");
      var cartOpen = document.querySelector("[data-cart-drawer]");
      if(!(cartOpen && cartOpen.classList.contains("open"))){
        overlay && overlay.classList.remove("show");
        document.body.style.overflow = "";
      }
    }
    if(btn){
      btn.addEventListener("click", function(){
        btn.classList.contains("open") ? close() : open();
      });
    }
    if(closeBtn){ closeBtn.addEventListener("click", close); }
    window._closeMobileMenu = close;
  }

  /* ---------------- FAQ accordion ---------------- */
  function initAccordion(){
    document.querySelectorAll("[data-faq-item]").forEach(function(item){
      var q = item.querySelector(".faq-q");
      var a = item.querySelector(".faq-a");
      q.addEventListener("click", function(){
        var isOpen = item.classList.contains("open");
        item.closest("[data-faq-group]") && item.closest("[data-faq-group]").querySelectorAll("[data-faq-item]").forEach(function(other){
          if(other !== item){
            other.classList.remove("open");
            other.querySelector(".faq-a").style.maxHeight = null;
            other.querySelector(".faq-q").setAttribute("aria-expanded","false");
          }
        });
        if(isOpen){
          item.classList.remove("open");
          a.style.maxHeight = null;
          q.setAttribute("aria-expanded","false");
        }else{
          item.classList.add("open");
          a.style.maxHeight = a.scrollHeight + "px";
          q.setAttribute("aria-expanded","true");
        }
      });
    });
  }

  /* ---------------- Sticky header shadow ---------------- */
  function initHeaderScroll(){
    var header = document.querySelector("[data-site-header]");
    if(!header) return;
    window.addEventListener("scroll", function(){
      header.classList.toggle("scrolled", window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------------- Back to top ---------------- */
  function initBackTop(){
    var btn = document.querySelector("[data-back-top]");
    if(!btn) return;
    window.addEventListener("scroll", function(){
      btn.classList.toggle("show", window.scrollY > 700);
    }, { passive: true });
    btn.addEventListener("click", function(){
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* ---------------- PDP gallery ---------------- */
  function initGallery(){
    var main = document.querySelector("[data-gallery-main]");
    var thumbs = document.querySelectorAll("[data-gallery-thumb]");
    if(!main || !thumbs.length) return;
    thumbs.forEach(function(t){
      t.addEventListener("click", function(){
        thumbs.forEach(function(x){ x.classList.remove("active"); });
        t.classList.add("active");
        var src = t.getAttribute("data-full");
        main.style.opacity = "0";
        setTimeout(function(){
          main.src = src;
          main.style.opacity = "1";
        }, 150);
      });
    });
  }

  /* ---------------- Qty steppers (standalone, e.g. PDP buy box / highlight) ---------------- */
  function initStandaloneSteppers(){
    document.querySelectorAll("[data-qty-standalone]").forEach(function(stepper){
      var display = stepper.querySelector("[data-qty-value]");
      var dec = stepper.querySelector("[data-qty-dec]");
      var inc = stepper.querySelector("[data-qty-inc]");
      if(!display || !dec || !inc) return; // guard: skip malformed steppers
      var val = 1;
      function render(){ display.textContent = val; }
      dec.addEventListener("click", function(){ if(val > 1){ val--; render(); } });
      inc.addEventListener("click", function(){ if(val < 10){ val++; render(); } });
      stepper._getQty = function(){ return val; };
    });
  }

  /* ---------------- Add to cart buttons ---------------- */
  function initAddToCart(){
    document.querySelectorAll("[data-add-to-cart]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var stepperSel = btn.getAttribute("data-qty-source");
        var qty = 1;
        if(stepperSel){
          var stepper = document.querySelector(stepperSel);
          if(stepper && stepper._getQty){ qty = stepper._getQty(); }
        }
        addToCart(qty);
      });
    });
    document.querySelectorAll("[data-buy-now]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var stepperSel = btn.getAttribute("data-qty-source");
        var qty = 1;
        if(stepperSel){
          var stepper = document.querySelector(stepperSel);
          if(stepper && stepper._getQty){ qty = stepper._getQty(); }
        }
        addToCart(qty);
        showToast("Demo — checkout connects to Shopify on the live store");
      });
    });
  }

  /* ---------------- Forms ---------------- */
  function initForms(){
    var newsletter = document.querySelector("[data-newsletter-form]");
    if(newsletter){
      newsletter.addEventListener("submit", function(e){
        e.preventDefault();
        showToast("Thanks for joining the VaidicHerb family! 🌿 Check your inbox.");
        newsletter.reset();
      });
    }
    var contact = document.querySelector("[data-contact-form]");
    if(contact){
      contact.addEventListener("submit", function(e){
        e.preventDefault();
        showToast("Message sent — we'll reply within 24 hours.");
        contact.reset();
      });
    }
  }

  /* ---------------- Cart drawer wiring ---------------- */
  function initCartDrawer(){
    document.querySelectorAll("[data-cart-open]").forEach(function(btn){
      btn.addEventListener("click", openCart);
    });
    document.querySelectorAll("[data-cart-close]").forEach(function(btn){
      btn.addEventListener("click", closeCart);
    });
    var overlay = document.querySelector("[data-overlay]");
    if(overlay){
      overlay.addEventListener("click", function(){
        closeCart();
        if(window._closeMobileMenu) window._closeMobileMenu();
      });
    }
    var checkoutBtn = document.querySelector("[data-cart-checkout]");
    if(checkoutBtn){
      checkoutBtn.addEventListener("click", function(){
        showToast("Demo — checkout connects to Shopify on the live store");
      });
    }
  }

  /* ---------------- Nav active link ---------------- */
  function markActiveNav(){
    var page = (location.pathname.split("/").pop() || "index.html");
    document.querySelectorAll("[data-nav-link]").forEach(function(a){
      var href = a.getAttribute("href");
      if(href === page || (page === "" && href === "index.html")){
        a.classList.add("active");
      }
    });
  }

  /* ---------------- Init ---------------- */
  document.addEventListener("DOMContentLoaded", function(){
    initMobileMenu();
    initAccordion();
    initHeaderScroll();
    initBackTop();
    initGallery();
    initStandaloneSteppers();
    initAddToCart();
    initForms();
    initCartDrawer();
    markActiveNav();
    renderCart();
  });
})();
